"use client";

import { CrashScreen } from "@/components/error/crash-screen";
import { useClientLocale } from "@/lib/i18n/use-client-locale";
import { inter } from "./fonts/inter";
import "./globals.css";

export default function GlobalError({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	// Root boundary: no parent [locale] layout, no next-intl context. Locale
	// is detected client-side from the URL — see useClientLocale.
	const locale = useClientLocale();

	return (
		<html lang={locale} suppressHydrationWarning className={inter.variable}>
			<head>
				<meta charSet="utf-8" />
				<meta name="viewport" content="width=device-width, initial-scale=1" />
				<title>Loker Dollar</title>
				<link rel="icon" href="/favicon.svg" type="image/svg+xml" />
				{/* Detect system dark mode preference before first paint */}
				<script
					// biome-ignore lint/security/noDangerouslySetInnerHtml: Inline dark-mode detection — no user input
					dangerouslySetInnerHTML={{
						__html: `try{if(window.matchMedia('(prefers-color-scheme:dark)').matches)document.documentElement.classList.add('dark')}catch(e){}`,
					}}
				/>
			</head>
			<body className="bg-background font-sans text-foreground antialiased">
				<CrashScreen locale={locale} error={error} reset={reset} />
			</body>
		</html>
	);
}
